import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from './navbar.module.scss';

const Navbar = () => {
	
	const navigate = useNavigate();
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropDownMenuRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (dropDownMenuRef.current) {
            if (!showDropdown) {
                dropDownMenuRef.current.style.display = 'none';
            } else {
                dropDownMenuRef.current.style.display = 'block';
            }
        }
    }, [showDropdown]);

    const navigateToContactUs = () => {
        navigate('/contact');
        setShowDropdown(false); 
    };
	const navigateToHome = () => {
		navigate('/');
		setShowDropdown(false); 
	}
	const navigateToAbout = () => {
		navigate('/about');
		setShowDropdown(false); 
	}

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

	const navigateToHealth = () => {
        navigate('/health');
        setShowDropdown(false); 
    };
	const navigateToDashboard = () => {
		navigate('/dashboard');
		setShowDropdown(false); 
	}
	return (
		<>
			<nav className={screenWidth >= 1250 ? Styles.navbar : Styles.mobileNavbar}>

				{ screenWidth >= 1250 && (
				<div className={Styles.wrapper}>
					<div className={Styles.logo}>
						<img
							className={Styles.vtlogo}
							src={require('../../assets/logo.webp')}
							onClick={()=>{navigateToHome();
								 setShowDropdown(false);}}
							// width='80px'
							height='80px'
							alt='logo'
							rel='preload'
						/>
					</div>
				
					<div className={Styles.links}>
					<div className={Styles.link}onClick={navigateToHome}>HOME</div>
					<div className={Styles.link}onClick={navigateToDashboard}>DASHBOARD</div>
					<div className={Styles.link}onClick={navigateToHealth}>HEALTH AND PRECAUTIONS</div>
					<div className={Styles.link}onClick={navigateToAbout}>ABOUT</div>
					<div className={Styles.link}onClick={navigateToContactUs}>CONTACT US</div>	
					</div>
				
					</div>
				)}
			
			{ screenWidth < 1250 && (
			<div className={Styles.mobileNavbar}>
				<div className={Styles.wrapper}>
					<div className={Styles.logo}>
						<img
							className={Styles.vtlogoMobile}
							src={require('../../assets/logo.webp')}
							onClick={toggleDropdown}
							alt='logo'
							rel='preload'
						/>
					</div>
				</div>
			</div>
			)}
			

			{ screenWidth < 1250 && (
			<div ref={dropDownMenuRef} id={Styles.linkContainer}>
				<div className={Styles.links}>
					<div className={Styles.link}onClick={navigateToHome}>HOME</div>
					<div className={Styles.link}onClick={navigateToDashboard}>DASHBOARD</div>
					<div className={Styles.link}onClick={navigateToHealth}>HEALTH AND PRECAUTIONS</div>
					<div className={Styles.link}onClick={navigateToAbout}>ABOUT</div>
					<div className={Styles.link}onClick={navigateToContactUs}>CONTACT US</div>
				</div>
			</div>
			)}
			</nav>
		</>
	);
};

export { Navbar };
